import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const CHECKOUT_URL = 'https://geometria-sagrada.impultienda.ar/checkout/geometria-sagrada';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-231" data-mp="aigh4gnge5lb">
      {glow && <div className="absolute inset-x-[12%] top-10 -z-10 h-48 rounded-full bg-brand-violet/25 blur-3xl" aria-hidden="true" data-id="element-232" data-mp="20s003dfrkzfw" />}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'gold' | 'violet';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'gold'
}: CTAButtonProps) {
  const reduceMotion = useReducedMotion();
  const colorClass = variant === 'gold' ? 'bg-brand-gold text-brand-deep hover:bg-brand-goldDark' : 'bg-brand-violetDark text-white hover:bg-brand-violet';
  return <motion.a href={href} whileHover={reduceMotion ? undefined : {
    scale: 1.02,
    y: -1
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`cta-shimmer relative inline-flex items-center justify-center rounded-full px-8 py-4 text-center text-base font-bold shadow-[0_10px_28px_rgba(233,196,106,0.22)] transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-goldLight ${colorClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-233" data-mp="2gszevuos32jz">
      <span className="relative z-10" data-id="element-234" data-mp="2bz84ihu0xcl6">{children}</span>
    </motion.a>;
}